var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { Ptn, } from "../../../utils/api/result-category/dataAccess";
import Dropdown from "../Dropdown";
export const ResultCategoryDropDown = ({ value, onChange, disabled = false, trialID, }) => {
    const [resultCategories, setResultCategories] = useState([]);
    useEffect(() => {
        const fetchResultCategories = () => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield Ptn.ResultCategory.GetResultCategories(trialID);
            setResultCategories(result);
        });
        fetchResultCategories();
    }, [trialID]);
    return (React.createElement(Dropdown, { items: resultCategories, displayName: "categoryName", displayValue: "id", label: "Category", value: value, onChange: onChange, labelPosition: "top", disabled: disabled }));
};
export default ResultCategoryDropDown;
